var _module = require('../../module');

require('../../../services/lr-touch');
require('../../../filters');

_module.component('sqfeetslider', {
    bindings: {
        min: '<',
        max: '<',
        totalHomes: '@',
        onGotoResults: '&',
        onSelect: '&',
        onUpdate: '&'
    },
    controllerAs: 'sqfeetslider',
    controller: [
        '$log',

        function sqfeetCtrl($log) {
            var _this = this;

            this.sqfeet = 2500;
            this.percent = Math.round(this.sqfeet / parseInt(this.max) * 100);
            this.sliderOptions = {
                floor: parseInt(this.min),
                ceil: parseInt(this.max)
            };

            // Functions
            this.onDrag = function onDrag(e) {
                var value = Math.round(e.percentX * 100) / 100 * parseInt(_this.max);

                if(value !== _this.sqfeet) {
                    _this.sqfeet = value;
                    _this.percent = e.percentX * 100;
                    _this.onUpdate({ $value: value });
                }
            };

            this.next = function next() {
                var value = _this.sqfeet === parseInt(this.max) ? null : _this.sqfeet;

                _this.onSelect({ $value: value });
            };
        }
    ],
    template: require('./index.html')
});
